import React, { useState, useEffect, useRef, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FilterMatchMode } from 'primereact/api';
import { ApplicationService } from '../../service/ApplicationService';
import { translatedMessage } from '../../service/LanguageService';
import DataTableUtils from '../../utilities/DataTableUtils';
import ApplicationDataTableUtils from '../../utilities/ApplicationDataTableUtils';
import CompetitionDataTableUtils from '../../utilities/CompetitionDataTableUtils';


const UserApplicationList = (props) => {
    const [applications, setApplications] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [filters] = useState({
        'competition.name': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'competition.institution.name': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const toast = useRef(null);
    const dt = useRef(null);

    const applicationService = useMemo(() => new ApplicationService(), []);

    useEffect(() => {
        setIsLoading(true);

        const getApplications = async () => {
            await applicationService.getAllCompetitionForUser(props?.application.id)
                .then((applications) => {
                    setApplications(applications)
                    setIsLoading(false)
                })
                .catch((error) => toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }))
        }

        getApplications()
    }, [props, applicationService])

    if (isLoading) {
        return (
            <div className="w-full flex align-items-center">
                <Toast ref={toast} />
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <h3 className="mb-0">{translatedMessage('user.competition.list')}</h3>

                <DataTable
                    ref={dt}
                    value={applications}
                    dataKey="id"
                    paginator
                    rows={DataTableUtils.defalRowsPerPage()}
                    rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                    className="datatable-responsive pcn-datatable"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                    emptyMessage={translatedMessage('generic.tableEmptyMessage')}
                    responsiveLayout="scroll"
                    filterDisplay="row"
                    filters={filters}
                    globalFilterFields={['competition.name', 'competition.institution.name']}
                >
                    <Column
                        field="competition.name"
                        header={translatedMessage('competition.competition')}
                        sortable
                        headerStyle={{ width: '20%', minWidth: '10rem' }}
                        filter
                        showFilterMenu={false}
                    />
                    <Column
                        field="status"
                        header={translatedMessage('generic.status')}
                        body={(e) => ApplicationDataTableUtils.statusBodyTemplate(e.status)}
                        sortable
                        headerStyle={{ width: '15%', minWidth: '10rem' }}
                    />
                    <Column
                        field="competition.institution.name"
                        header={translatedMessage('competition.institution')}
                        sortable
                        headerStyle={{ width: '20%', minWidth: '8rem' }}
                        body={(e) => e.competition.institution.name}
                        filter
                        showFilterMenu={false}
                    />
                    <Column
                        field="competition.status"
                        header={translatedMessage('competition.status')}
                        body={(e) => CompetitionDataTableUtils.statusBodyTemplate(e.competition)}
                        sortable
                        headerStyle={{ width: '15%', minWidth: '10rem' }}
                    />
                </DataTable>
            </>
        );
    }
};

export default UserApplicationList;
